const text = {
  discount: '¡Pregunta por la promo de verano! 🔥',
  hot: '',
}
export default text
